!function(name, module, context){
	if(window.define) define('common/smartHomePage',['vendor/mustache','vendor/moment.min'], module)
	else
		context[name] = module(Mustache)
}('smartHomePage', function(Mustache){


	var smartHomePageView = {
		$el : $('#smartHomePageTrip'),
		render : function(){
			var smartHomePageTripType = { 
				flight : "1",
				hotel : "2",
				train : "4"
			};

			function tripType (data){
				var data = data;
				data.isFlight = data.trip_type == smartHomePageTripType.flight ? true : false;
				data.isHotel = data.trip_type == smartHomePageTripType.hotel ? true : false;
				data.isTrain = data.trip_type == smartHomePageTripType.train ? true : false;
				data.bookin_type = "";
				if(data.isFlight){
					data.bookin_type = "plane";
				} else if(data.isHotel){
					data.bookin_type = "hotel";
				} else if(data.isTrain){
					data.bookin_type = "train";
				}

				data.tripTitle = tripTitle(data);
				data.trip_date = convertDate(data.trip_date);
				data.travellerMsg = travellersMsgDisp(data.travellers);
				return data;
			}

			function convertDate(tripDate){ 
				var tripDate = moment(tripDate).startOf('day');
				var currentDate = moment(window.serverCurrentDate).startOf('day');
				var dateDiff = tripDate.diff(currentDate,'days');
				switch(dateDiff){
					case 0:
						return "Today";
					case 1:
						return "Tomorrow";
					default :
						return moment(tripDate).format("MMM DD");
				}	
			}

			function slaDate(date){
				var tripDate = moment(date).startOf('day');
				var currentDate = moment(window.serverCurrentDate).startOf('day');
				var dateDiff = tripDate.diff(currentDate,'days');
				switch(dateDiff){
					case 0:
						return "today, "+moment(date).format("hA");
					case 1:
						return "tomorrow, "+moment(date).format("hA");
					default :
						return moment(date).format("ddd, DD MMM");
				}	
			}

			function getRefundDetails(data){
				var data = data, detail={};
				switch(data.trip_type){
					case smartHomePageTripType.flight : //Flight
					    detail = getFlightRefundDetails(data);
						break;
					case smartHomePageTripType.hotel : //Hotel
						detail = data.hotels[0].refund_details[0];
						break;
					case smartHomePageTripType.train : //Train
						detail = data.trains[0].refund_details[0];
						break;
					default :
						break;
				}
				return detail;
			}

			function getFlightRefundDetails(data){
				var detail = {};
				var type= data.journey_type.toUpperCase();
				switch(type){
					case 'OW': //One Way
						detail = data.flights[0].refund_details[0];
						detail.tripCancellationMsg=tripCancellationMsg(detail,data.partial_cancellation);
						break;
					case 'RT': //Round Trip
						detail = getFlightRefundData(data);
						break;
					case 'MC': //Multi City
						detail = getFlightRefundData(data);
						break;
					default : 
						break;
				}
				return detail;
			}

			function getFlightRefundData(data){ //This method is called for Multileg flight(RT/MC)
				var refundDetails = {};

				//Sort Data based on cancellation time
				var sortByCancelledTime = function(a,b){
					if(a.refund_details.length == 0 && b.refund_details.length == 0){
						return -1;
					}else if(a.refund_details.length == 0){
						return 1;
					}else if(b.refund_details.length == 0){
						return -1;
					}else{
						a = moment(a.refund_details[0].cancelled_time).valueOf(); //convert time in ms
						b = moment(b.refund_details[0].cancelled_time).valueOf(); //convert time in ms
						return b-a;
					}
				};
				data.flights=data.flights.sort(sortByCancelledTime);

				//Get Latest cancellation data
				var cancelled_time = moment(data.flights[0].refund_details[0].cancelled_time).valueOf();
				var flightDataLen = data.flights.length;
				var latestCancelled = _.filter(data.flights,function(ele){
					return ele.refund_details.length != 0 && cancelled_time == moment(ele.refund_details[0].cancelled_time).valueOf();
				});


				// Get latest cancellation data having same Pax
				var pax = latestCancelled[0].refund_details[0].cancelled_travellers_names.toString();
				var latestCancelledLen = latestCancelled.length;
				var samePaxData = _.filter(latestCancelled,function(ele){
					return pax == ele.refund_details[0].cancelled_travellers_names.toString();
				});

				//Total Pax Count
				var totalPax = 0; 
				totalPax = data.travellers.ADT ? (totalPax + data.travellers.ADT) :totalPax;
				totalPax = data.travellers.CHD ? (totalPax + data.travellers.CHD) :totalPax;
				totalPax = data.travellers.INF ? (totalPax + data.travellers.INF) :totalPax; 	

				var samePaxDataLen = samePaxData.length;

				//Decide Trip Cancellation Message
				var tripCancellationMsg = "";
				//If whole trip got cancelled at any particular time
				if(!data.partial_cancellation){
					//falls to 1st condition
					tripCancellationMsg = ("Trip cancelled on "+moment(latestCancelled[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
				}else{
					if(samePaxDataLen == latestCancelledLen){
						if(samePaxDataLen == 1){
							if(samePaxData[0].refund_details[0].cancelled_travellers_names.length == totalPax){
								//falls to 3rd condition
								tripCancellationMsg = samePaxData[0].from + "→"+ samePaxData[0].to + " cancelled on "+ moment(samePaxData[0].refund_details[0].cancelled_time).format("ddd DD MMM");
							}else{
								//falls to 4th condition
								var travellerDetails = samePaxData[0].refund_details[0].cancelled_travellers_names;
								tripCancellationMsg += samePaxData[0].from + "→"+ samePaxData[0].to + " cancelled for ";
								tripCancellationMsg += _.reduce(travellerDetails,function(prev,curr,currIdx,arr){
										return prev + ((currIdx > 0 ? (currIdx == (arr.length-1) ? " and " : ", " ): "" )+curr);
								},"");
								tripCancellationMsg += (" on " + moment(samePaxData[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
							}
						}else{
							if(latestCancelledLen == flightDataLen){
								var paxString = samePaxData[0].refund_details[0].cancelled_travellers_names.toString();
								var count = _.filter(samePaxData, function(val) {
									return paxString == val.refund_details[0].cancelled_travellers_names.toString();
								}).length;

								if(count == samePaxDataLen){
									//falls to 2nd condition
									var travellerDetails = samePaxData[0].refund_details[0].cancelled_travellers_names;
									tripCancellationMsg += "Trip cancelled for ";
									tripCancellationMsg += _.reduce(travellerDetails,function(prev,curr,currIdx,arr){
										return prev + ((currIdx > 0 ? (currIdx == (arr.length-1) ? " and " : ", " ): "" )+curr);
									},"");
									tripCancellationMsg += (" on " + moment(samePaxData[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
								}else{
									//falls to 5th condition
									tripCancellationMsg += ("Part of this trip cancelled on "+ moment(latestCancelled[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
								}
							}else{
								//falls to 5th condition
								tripCancellationMsg += ("Part of this trip cancelled on "+ moment(latestCancelled[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
							}
						}
					}else{
						//falls to 5th condition
						tripCancellationMsg += ("Part of this trip cancelled on "+ moment(latestCancelled[0].refund_details[0].cancelled_time).format("ddd DD MMM"));
					}
				}
				
				//Calculate Total Refund Amount
				var refundAmt ;
				if(data.sp_rt_fare){
					refundAmt = latestCancelled[0].refund_details[0].refund_amount;
				}else{
					refundAmt = _.reduce(latestCancelled,function(amt,ele){
						return amt + Number(ele.refund_details[0].refund_amount)
					},0)
				}

				refundDetails = {
                    "step": latestCancelled[0].refund_details[0].step, 
                    "refund_status": latestCancelled[0].refund_details[0].refund_status, 
                    "cancelled_time": latestCancelled[0].refund_details[0].cancelled_time, 
                    "refund_not_recieved_url": latestCancelled[0].refund_details[0].refund_not_recieved_url, 
                    "refund_amount": refundAmt,
                    "refund_currency": data.currency, 
                    "sla": latestCancelled[0].refund_details[0].sla,
                    "tripCancellationMsg" :tripCancellationMsg
				}

				return refundDetails;
			}

			function travellersMsgDisp (obj){  //Msg display below title , e.g. : 1 adult, 2 childs
				var msg = "";
				var adult = obj.ADT == undefined ? 0 : obj.ADT;
				var child = obj.CHD == undefined  ? 0 : obj.CHD;
				var infant = obj.INF == undefined ? 0 : obj.INF;
				msg += adult > 0 ? (adult + (adult > 1 ? " Adults"  : " Adult")) : "";
				msg += child > 0 ? ((adult > 0 ? ", "  : "") + child + (child > 1 ? " Childs"  : " Child")) : "";
				msg += infant > 0 ? (((adult > 0 || child >0) ? ", " : "") + infant + (infant > 1 ? " Infants" : " Infant")) : "";
				return msg;
			}

			function flightTripTitle (flight,type){    //Title for flight trip e.g.: Pune → Bangalore
				var title = "";
				switch(type.toUpperCase()){
					case 'OW': //One Way
						title = flight[0].from + " → "+ flight[flight.length-1].to; 
						break;
					case 'RT': //Round Trip
						title = flight[0].from + " ⇄ "+ flight[0].to; 
						break;
					case 'MC': //Multi City
						title = flight[0].from;
						title += _.reduce(flight,function(prev,curr){
							return prev + " → "+ curr.to;
						},"")

						break;
					default : 
						break;
				}
				return title;
			}

			function tripTitle (data){ //Title for Trip  e.g : Hotel TAP Gold Crest
				var title= "";
				switch(data.trip_type){
					case smartHomePageTripType.flight :  //Flight
						title = flightTripTitle (data.flights,data.journey_type);
						break;
					case smartHomePageTripType.hotel :   //Hotel
						title = data.hotels[0].name;
						break;
					case smartHomePageTripType.train :   //Train
						title = data.trains[0].from_station + "  → " +data.trains[0].to_station;
						break;
					default:
						break;
				}
				return title;
			}

			function dispCurrency (curr){
				switch(curr.toUpperCase()){
					case 'INR' : 
						return 'Rs.';
					default :
						return curr;
				}
			}
			function getMostUpcomingFlightTrip(flights){
				var currentDate = moment(window.serverCurrentDate);
				var flightData = _.filter(flights,function(ele){
					return moment(ele.departure_date_time).diff(currentDate,'milliseconds') >= 0;
				});
				return flightData[0];
			}

			function tripCancellationMsg(refundDetails,partialCancellation){
				var msg = "";	
				if(partialCancellation){
					var travellerDetails = refundDetails.cancelled_travellers_names;
					msg += "Trip cancelled for ";
					msg += _.reduce(travellerDetails,function(prev,curr,currIdx,arr){
						return prev + ((currIdx > 0 ? (currIdx == (arr.length-1) ? " and " : ", " ): "" )+curr);
					},"");
					msg += (" on " + moment(refundDetails.cancelled_time).format("ddd DD MMM"));
				}
				else{
					msg += ("Trip cancelled on " + moment(refundDetails.cancelled_time).format("ddd DD MMM"));
				}
				return msg;
			}

			function refundDetailsMsg(refundDetails){
				var msg = "";
				var currentDate = moment(window.serverCurrentDate);
				var isPastSlaDate = moment(refundDetails.sla).diff(currentDate,'milliseconds') < 0;
				var refundAmt = parseFloat(refundDetails.refund_amount);
				var noRefMsg = "There is no refund applicable for this trip";
				switch(refundDetails.step){
					case "1":
						msg += (!isPastSlaDate ? ("We will update you with the refund amount by " +slaDate(refundDetails.sla)) : "We are sorry as we couldn't update you with refund amount in time. We'll keep you updated.");
						break;
					case "2":
						if(refundAmt<=0){
							msg += noRefMsg;
						}else{
							msg += (!isPastSlaDate ? ("We will start the transfer of " + dispCurrency(refundDetails.refund_currency) + " " + refundDetails.refund_amount + " to your payment method by " +slaDate(refundDetails.sla)) : ("We are sorry as we couldn't start the transfer of " + dispCurrency(refundDetails.refund_currency) + " " + refundDetails.refund_amount + " to your payment method by "+slaDate(refundDetails.sla)+". We'll keep you updated about the progress."));
						}
						break;
					case "3":
						if(refundAmt<=0){
							msg += noRefMsg;
						}else{
							msg += (dispCurrency(refundDetails.refund_currency) + " " + refundDetails.refund_amount + " should be credited in your original payment method by " +slaDate(refundDetails.sla));
						}
						break;
					default:
						break;
				}

				return msg;
			}
			function upComingTripDataToBeSent (data){ // For Upcoming trip, data needs to be sent for Mustache template
				var data = data;
				data = tripType(data); 
				data.isTripDateShow = true;
				if(data.isFlight){
					//data.flights = data.flights[0]; // for via flight/city we will show details for 1st sequence/leg
					data.flights = getMostUpcomingFlightTrip(data.flights);
					if(data.journey_type != "OW"){
						data.isTripDateShow = false;
						data.flights.mostUpcomingTripMSg = "Flight from "+ data.flights.from + " on "+ moment(data.flights.departure_date_time).format("ddd, DD MMM");
					}
					data.flights.departure_date_time = moment(data.flights.departure_date_time).format("HH:mm")+"hrs";
				}
				if(data.isHotel){
					data.hotels = data.hotels[0];
					var fullCityName = data.hotels.full_city_name.split(",");
					data.hotels.cityName = fullCityName[0];
					data.hotels.country =  fullCityName[2];
					data.hotels.check_in_time = moment(data.hotels.check_in_date).format("HH:mm")+"hrs";
					data.hotels.hotel_location_url = '/hotels/details/'+data.hotels.hotel_id+'?c=&r=&mapOnly=#location';
					data.hotels.isRoom = data.hotels.room_count > 1 ? false : true ;
				}
				if(data.isTrain){
					data.trains = data.trains[0];
				}
				data.isAmendAvailable = window.countryCode.toLowerCase() == 'in' ? true : false; 
				return data;
			}

			function partPayTripDataToBeSent (data){  // For Part Payment trip, data needs to be sent for Mustache template
				var data = data;
				data = tripType(data); 
				data.pending_payment_details.payment_due_date = moment(data.pending_payment_details.payment_due_date).format("Do MMM, YYYY");
				data.pending_payment_details.disp_currency = dispCurrency(data.pending_payment_details.currency);
				data.pending_payment_details.payment_url = "https://" + window.location.host + data.pending_payment_details.payment_url;

				return data;
			}

			function refundTripDataToBeSent (data){ // For Cancelled/Refunded trip, data needs to be sent for Mustache template
				var data = data;
				data = tripType(data); 
				data.refund_details = getRefundDetails(data);
				data.refund_details.is_step_one = data.refund_details.step == "1" ? true : false;
				data.refund_details.is_step_two = data.refund_details.step == "2" ? true : false;
				data.refund_details.is_step_three = data.refund_details.step == "3" ? true : false;
				if(!data.isFlight){
					data.refund_details.tripCancellationMsg = tripCancellationMsg(data.refund_details,data.partial_cancellation);
				}
				data.refund_details.refund_currency = data.currency;
				data.refund_details.message = refundDetailsMsg(data.refund_details);
				var refundAmt = parseFloat(data.refund_details.refund_amount);
				data.refund_details.is_refund_not_recieved_link_show = (refundAmt<=0) ? false : true;
 				return data;
			}

			function setDelayedEvent() { //Adding 200 ms delay for ga push event to be completed
				$("#smartHomePageTrip a[appref='true']").bind('click',function(e){
					if($(e.target).attr("target") != "_blank"){
						e.preventDefault();
						setTimeout(function() { 
							window.location.href= e.target.href;
						},200);
					}
				})
			}

			function showTripTools(){
				if (CT.utils.cookies.read('booking') || CT.utils.cookies.read('bookedFlight')){
					$('.toolsFlight').css('display', 'block');
					window._gaq = window._gaq || []; 
					_gaq.push(['_trackEvent', 'account', 'trip_tools_load', 'flights']);
					CT.utils.helperFunctions.adjustHeight();
				}
				if (CT.utils.cookies.read('booking') || CT.utils.cookies.read('bookedHotel')){
					$('.toolsHotel').css('display', 'block');
					window._gaq = window._gaq || []; 
					_gaq.push(['_trackEvent', 'account', 'trip_tools_load', 'hotels']);
					CT.utils.helperFunctions.adjustHeight();
				}
			}

			function trackSmartHomePageLoad(tripType){
				var prodype = "";
				var action ="";
				switch (tripType){
					case smartHomePageTripType.flight :
						prodype = "AIR";
						break;
					case smartHomePageTripType.hotel :
						prodype = "HOTEL"; 
						break;
					case smartHomePageTripType.train :
						prodype = "TRAIN";
						break;
					default :
						break;
				}
				action = "SHP_"+prodype+"_LOADED";
				if(window._gaq) 
					_gaq.push(['_trackEvent', 'account', action , window.location.pathname]);
			}	

			if(window.product != "B2B"){
				var authCookie = CT.utils.readCTAuthCookie();
				if(authCookie && window.smartHomePage){
					var that = this;
					var timeOutVal = 15000;
					var url = '/partial/account/trips/priority?source=shp&t='+new Date().getTime();
					 $.ajax({
					 	url: url,
					 	type:'GET',
					 	timeout : timeOutVal,
					 	success: function(data){
					 		var data = typeof(data) == "string" ? JSON.parse(data) : data;
						 	if(data && Object.keys(data).length >0){
						 		switch(data.type.toLowerCase()){
						 			case 'upcoming trips': 
								 		var homePageUpcomingTripData = upComingTripDataToBeSent(data);
								 		var html = CT.to_html("smartHomePageUpcomingTrip",homePageUpcomingTripData);
								 		that.$el.html(html).show();
								 		break;
								 	case 'refunds':
								 		var refundTripData = refundTripDataToBeSent(data);
								 		var html = CT.to_html("smartHomePageCancelTrip",refundTripData);
								 		that.$el.html(html).show();
								 		break;
								 	case 'part payment':
								 		var partPayTripData = partPayTripDataToBeSent(data);
								 		var html = CT.to_html("smartHomePagePartPayTrip",partPayTripData);
								 		that.$el.html(html).show();
								 		break;
								 	default : 
								 		break;
								}
								CT.utils.helperFunctions.forceHttpsLinks($("#smartHomePageTrip"));
								$("#smartHomePageTrip").addClass("smartWidget");
								CT.utils.helperFunctions.adjustHeight();
								setDelayedEvent();
								trackSmartHomePageLoad(data.trip_type);
					 		}else{
					 			showTripTools();
					 		}
		    			},
		    			error :function(e){
		    				showTripTools();
		    				//console.log(e);
		    			}
		    		});
				}else{
					showTripTools();
				}
			}else{
				showTripTools();
			}
		}
	};
		
	// smart Home Page View is initialized here.
	return smartHomePageView;

}, CT)
;
